import {Box, SkeletonBodyText} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';
import classNames from 'classnames';
import {TranslatableResourceType} from 'types';

import styles from '../TranslatableResourceTable/components/RowCellMarkup/RowCellMarkup.scss';
import {Table} from '../TranslatableResourceTable';

export interface Props {
  resourceType?: TranslatableResourceType;
}

export function TranslatableResourceTableSkeleton({resourceType}: Props) {
  const [i18n] = useI18n();

  return (
    <Table
      title={
        resourceType
          ? i18n.translate(`ResourceTypes.${resourceType}`, {count: 1})
          : ''
      }
    >
      {Array.from({length: 4}).map((_field, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <tr className={styles.Row} key={`row-${i}`}>
          <th className={styles.Row__Header} scope="row">
            <Box padding="100" paddingInlineStart="200" paddingInlineEnd="1000">
              <SkeletonBodyText lines={1} />
            </Box>
          </th>
          <td className={classNames(styles.RowCell, styles.RowCell__disabled)}>
            <Box
              padding="100"
              paddingBlockStart="300"
              paddingInlineStart="500"
              paddingInlineEnd="2000"
            >
              <SkeletonBodyText lines={1} />
            </Box>
          </td>
          <td className={styles.RowCell}>
            <Box
              padding="100"
              paddingBlockStart="300"
              paddingInlineStart="500"
              paddingInlineEnd="2000"
            >
              <SkeletonBodyText lines={1} />
            </Box>
          </td>
        </tr>
      ))}
    </Table>
  );
}
